import React, { useContext, useEffect, useState } from 'react';

import { Tooltip } from '@material-ui/core';

import { UserInviteContext } from '@/core/users/UserInvite/UserInviteContext';
import { UserInviteErrors } from '@/core/users/UserInvite/userInviteValidation';
import { ReactComponent as SendMailIcon } from '@/icons/send_mail.svg';

const DEFAULT_CLASSES = 'flex items-center px-6 py-4 rounded font-medium evt-invite-users whitespace-nowrap';
const ENABLED_CLASSES = 'text-gray-100 bg-blue-900';
const DISABLED_CLASSES = 'text-gray-600 bg-gray-200';

export function UserInviteSubmitButton () {
  const { billingRate, errors, isValidating, sendInvite, submitCount, toggleConfirmModal } = useContext(UserInviteContext);
  const [inviteQueued, setInviteQueued] = useState(false);
  const errorKeys = Object.keys(errors);
  const isDisabled = submitCount > 0 && errorKeys.length > 0;

  const onClick = () => {
    // Billing rate will be defined when rate has changed
    if (billingRate) {
      toggleConfirmModal();
    } else {
      sendInvite();
    }
  };

  useEffect(() => {
    if (inviteQueued && !isValidating) {
      sendInvite();
      setInviteQueued(false);
    }
  }, [isValidating]);

  return (
    <Tooltip title={errorKeys.length === 0 ? '' : errors[errorKeys[0] as keyof UserInviteErrors]!}>
      <button
        className={`${DEFAULT_CLASSES} ${isDisabled ? DISABLED_CLASSES : ENABLED_CLASSES}`}
        style={{ width: 210 }}
        onClick={isDisabled ? undefined : isValidating ? () => setInviteQueued(true) : onClick}
      >
        <SendMailIcon className="w-5 h-4 mr-3" />
        {inviteQueued ? 'Submitting...' : isValidating ? 'Validating...' : 'Send invitation(s)'}
      </button>
    </Tooltip>
  );
}
